import { createColumnHelper } from '@tanstack/react-table';
import { DateTime } from 'luxon';

import { PaymentAmountCell } from './cells/PaymentAmountCell';
import { PaymentsActionCell } from './cells/PaymentsActionsCell';
import {
  InvoicePaymentRead,
  TilledPaymentMethodResponse,
} from 'src/common/external/bambi-api/bambiApi';
import { CreditCardBrand } from 'src/common/primitives/icon/CreditCardBrand/CreditCardBrand';
import { CreditCardPaymentMethod } from 'src/common/primitives/PaymentMethod/CreditCardPaymentMethod';

export type InvoicePaymentWithPaymentMethod = InvoicePaymentRead & {
  paymentMethod?: TilledPaymentMethodResponse;
};

const columnHelper = createColumnHelper<InvoicePaymentWithPaymentMethod>();

export const columns = [
  columnHelper.accessor('created_at', {
    header: 'Date',
    cell({ getValue }) {
      return DateTime.fromISO(getValue()).toLocaleString(
        DateTime.DATETIME_SHORT
      );
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('amount_cents', {
    header: 'Amount',
    cell({ getValue, row }) {
      return (
        <PaymentAmountCell
          amountCents={getValue()}
          chargeStatus={row.original.charge_status}
          refunds={row.original.refunds}
          paymentFailureMessage={row.original.failure_message}
          isManual={row.original.is_manual}
          payment={row.original}
        />
      );
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.display({
    id: 'paymentMethod',
    header: 'Payment Method',
    cell({ row }) {
      const paymentMethod = row.original.paymentMethod;

      if (!paymentMethod || row.original.is_manual) {
        return <div>&mdash;</div>;
      }

      return (
        <CreditCardPaymentMethod
          id={paymentMethod.id}
          brand={paymentMethod.card.brand as CreditCardBrand}
          last4={paymentMethod.card.last4}
          expMonth={paymentMethod.card.exp_month}
          expYear={paymentMethod.card.exp_year}
          holderName={paymentMethod.card.holder_name}
          billingDetails={paymentMethod.billing_details}
          isPaymentLink={!!row.original.payment_link}
        />
      );
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('note', {
    header: 'Note',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('charge_status', {
    header: 'Status',
    meta: {
      enableHeaderMenu: false,
    },
    cell({ row }) {
      return (
        <div data-testid="charge-status-cell">{row.original.charge_status}</div>
      );
    },
  }),
  columnHelper.display({
    id: 'actions',
    header() {
      return <>&nbsp;</>;
    },
    cell({ row }) {
      return <PaymentsActionCell payment={row.original} />;
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
];
